import { render } from "./AgentForm.vue?vue&type=template&id=45e91132&scoped=true"
import script from "./AgentForm.vue?vue&type=script&lang=js"
export * from "./AgentForm.vue?vue&type=script&lang=js"

import "./AgentForm.vue?vue&type=style&index=0&id=45e91132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e91132"]])

export default __exports__